var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdv4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 247,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 4719,
    width: 254,
    height: 247
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-680 -4719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.789 19.525C178.789 19.525 275.774 103.18 249.327 185.43 249.327 185.43 221.843 271.324 79.1957 238.566 52.5257 232.449 29.1131 216.908 15.1721 194.824 8.37618 183.976 3.72275 171.935 1.4542 159.341-2.97626 135.483 2.85023 110.917 17.0141 90.6547 47.8819 46.4374 117.926-36.2386 178.789 19.525",
    fill: "#EBF2FC",
    transform: "matrix(1 0 0 1.00307 680 4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 4815.93C804.568 4815.93 801.787 4813.15 801.787 4809.72 801.787 4806.29 804.568 4803.5 808 4803.5 811.432 4803.5 814.214 4806.29 814.214 4809.72 814.207 4813.15 811.429 4815.93 808 4815.93ZM811.107 4881.17 811.107 4825.25 798.68 4825.25 798.68 4831.47 804.893 4831.47 804.893 4881.17 798.68 4881.17 798.68 4887.39 817.32 4887.39 817.32 4881.17ZM872 4847C872 4882.35 843.346 4911 808 4911 772.654 4911 744 4882.35 744 4847 744 4811.65 772.654 4783 808 4783 843.336 4782.99 871.99 4811.63 872 4846.96 872 4846.98 872 4846.99 872 4847ZM865.787 4847C865.787 4815.09 839.915 4789.21 808 4789.21 776.085 4789.21 750.213 4815.09 750.213 4847 750.213 4878.91 776.085 4904.79 808 4904.79 839.901 4904.75 865.752 4878.9 865.787 4847Z",
    fill: "#1913AB",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv4);
export default __webpack_public_path__ + "static/media/adv4.2983a30fcb50f5d9111b86ebe2f447ff.svg";
export { ForwardRef as ReactComponent };